import * as Yup from 'yup';

import { Field, Form, Formik } from 'formik';
import React, { Component } from 'react';

import ApiService from '../../../service/api.service';
import Button from '../../../components/UI/Button/Button';
import Input from '../../../components/UI/Input/Input';
import RequiredInput from '../../../components/UI/Input/RequiredInput/RequiredInput';
import PasswordInput from '../../../components/UI/Input/PasswordInput/PasswordInput';
import { Link } from 'react-router-dom';
import PageMeta from '../../../components/UI/PageMeta/PageMeta';
import Popup from 'reactjs-popup';
import ReactHtmlParser from 'react-html-parser';
import SlickSlider from '../../../components/UI/SlickSlider/SlickSlider';
import confirmBig from '../../../assets/images/thankYpuSectionImage.svg';
import imageLogo from '../../../assets/images/Aura-big-logo.svg';
import loader from '../../../assets/images/loader.svg';
import SecurityFooter from '../../../components/UI/SecurityFooter/SecurityFooter';
import PasswordValidation from '../../../components/UI/PasswordValidation/PasswordValidation';

class Register extends Component {
    constructor(props) {
        super(props);
        this.buttonRef = React.createRef();
        this.state = {
            isRegistered: false,
            focusedName: 'false',
            focusedEmail: 'false',
            focusedPassword: 'false',
            errorMessage: '',
            loading: false,
            terms: '',
            user: null,
            confirmationEmail: false,
            buttonLoading: false,
        };
    }

    componentDidMount() {
        ApiService.infoPages()
            .then((r) => {
                this.setState({
                    terms: r.data[2].content,
                    termsTitle: r.data[2].title,
                });
            })
            .catch((e) => {
                console.log(e);
            });
    }

    handleResendVerificationLink = () => {
        this.buttonRef.current.blur();
        this.setState({ buttonLoading: true }, () => {
            const params = {
                id: this.state.user.id,
            };
            ApiService.resendVerificationEmail(params).then((r) => {
                this.setState(
                    { buttonLoading: false, confirmationEmail: true },
                    () => {
                        setTimeout(() => {
                            this.setState({ confirmationEmail: false });
                        }, 2500);
                    }
                );
            });
        });
    };

    handlePopupOpen = () => document.body.classList.add('modal-open');
    handlePopupClose = () => document.body.classList.remove('modal-open');

    render() {
        let register;

        if (this.state.isRegistered) {
            register = (
                <div className="c-thank-you-section o-flex o-flex-column o-flex-between o-flex-middle o-d-block-tablet text-center height-full height-tablet-auto">
                    <div className="c-thank-you-upper">
                        <a href="/">
                            <img
                                width="194"
                                height="94"
                                src={imageLogo}
                                alt="imageLogo"
                            />
                        </a>
                        <h1 className="c-thank-you-section__title font-36 font-333 font-family-secondary font-semibold">
                            Thank You for Registering
                        </h1>
                        <p className="c-thank-you-section__text1 font-secondary font-20 ">
                            Please Check your Email
                        </p>
                        <div className="position-relative margin-auto mt-20">
                            <img
                                className="z-index-1 c-thank-you-upper__confirm-img"
                                src={confirmBig}
                                alt="confirm-big"
                            />
                        </div>

                        <p className="c-thank-you-section__text2 font-18 font-333 margin-auto ">
                            The email contains a link so we can verify it's you
                            for security. Can't find it? Please check your junk
                            folder, or if you're still having trouble you can
                            contact us at{' '}
                            <a
                                className="font-semibold"
                                href="mailto:hello@aura.life"
                            >
                                hello@aura.life
                            </a>{' '}
                        </p>
                        <p className="c-thank-you-section__text3 font-18 font-333 margin-auto"></p>

                        <button
                            ref={this.buttonRef}
                            onClick={() => this.handleResendVerificationLink()}
                            className={`btn--size-54 btn-loader ${
                                this.state.buttonLoading
                                    ? 'save-in-progress'
                                    : ''
                            } btn btn--full  margin-reset`}
                        >
                            {this.state.confirmationEmail &&
                            !this.state.buttonLoading
                                ? 'Confirmation email has been resent'
                                : 'Resend email verification link'}
                            <img
                                width="100%"
                                height="100%"
                                src={loader}
                                alt="loaderImage"
                            />
                        </button>
                    </div>
                    <SecurityFooter tablet={true} />
                </div>
            );
        } else {
            register = (
                <div className="o-flex o-flex-end o-flex-middle overflow-both-hidden position-relative c-auth-page c-auth-page__register o-d-block-tablet overflow-y-tablet">
                    <SecurityFooter tablet={true} />
                    <Formik
                        initialValues={{
                            name: '',
                            email: '',
                            password: '',
                            newsletter: false,
                            userFullName: '',
                        }}
                        validationSchema={Yup.object({
                            name: Yup.string().required(
                                'This field is required.'
                            ),
                            email: Yup.string()
                                .email('Please enter a valid E-mail Address')
                                .required('This field is required.'),
                            password: Yup.string()
                                .min(8, '')
                                .matches(/[a-z]/, '')
                                .matches(/[A-Z]/, '')
                                .matches(/(?=.*[0-9])/, '')
                                .required('This field is required.'),
                            userFullName: Yup.string(),
                        })}
                        onSubmit={(values) => {
                            this.setState(
                                {
                                    loading: true,
                                },
                                () => {
                                    let data;
                                    if (values.userFullName === '') {
                                        data = {
                                            firstName: values.name,
                                            email: values.email,
                                            password: values.password,
                                            newsletter: values.newsletter,
                                        };
                                    } else {
                                        data = {
                                            firstName: values.name,
                                            email: values.email,
                                            password: values.password,
                                            newsletter: values.newsletter,
                                            user_full_name: values.userFullName,
                                        };
                                    }
                                    ApiService.registerUser(data)
                                        .then((r) => {
                                            this.setState({
                                                isRegistered: true,
                                                loading: false,
                                                user: r.data,
                                            });
                                        })
                                        .catch(() => {
                                            this.setState({
                                                errorMessage:
                                                    'Email address already in use!',
                                                loading: false,
                                            });
                                        });
                                }
                            );
                        }}
                    >
                        {(props) => {
                            return (
                                <>
                                    <div className="c-auth-page__auth-form c-auth-page__auth-form-register margin-auto o-flex-center o-flex-top o-flex-column o-d-block-tablet width-full">
                                        <PageMeta
                                            title="Create Your Aura"
                                            description="Create Your Aura"
                                            canonical={window.location.href}
                                        />
                                        <a
                                            class="o-flex o-flex-center o-flex-middle width-full"
                                            href="/"
                                        >
                                            <img
                                                width="110"
                                                height="94"
                                                className="c-auth-page__auth-form--logo"
                                                src={imageLogo}
                                                alt="logo"
                                            />
                                        </a>
                                        <p className="c-auth-page__auth-form--intro-text">
                                            Create a free, safe and secure Aura
                                            account
                                        </p>
                                        <Form
                                            name="form-register"
                                            noValidate
                                            className="o-flex o-flex-column c-auth-page__auth-form-register-fields"
                                        >
                                            <RequiredInput
                                                className="input"
                                                label="Enter your name"
                                                name="name"
                                                type="text"
                                            />
                                            <RequiredInput
                                                label="Email Address"
                                                name="email"
                                                type="Email"
                                            />
                                            <PasswordInput
                                                label="Password"
                                                name="password"
                                            />
                                            <PasswordValidation
                                                pw={props.values.password}
                                            />
                                            <div className="hide">
                                                <Input
                                                    name="userFullName"
                                                    type="text"
                                                    placeholder="User Full Name"
                                                />
                                            </div>
                                            <Field
                                                name="newsletter"
                                                type="checkbox"
                                                component={Checkbox}
                                            />
                                            <Button
                                                disabled={
                                                    props.errors.email ||
                                                    props.values.email === '' ||
                                                    props.values.name === '' ||
                                                    props.values.password
                                                        .length < 8 ||
                                                    'password' in props.errors
                                                }
                                                className={`btn btn--full btn-loader ${
                                                    this.state.loading
                                                        ? 'save-in-progress'
                                                        : ''
                                                } submit-button position-relative overflow-both-hidden z-index-1`}
                                                type="submit"
                                            >
                                                Create FREE Account{' '}
                                                <img
                                                    width="100%"
                                                    height="100%"
                                                    src={loader}
                                                    alt="loaderImage"
                                                />
                                            </Button>
                                            {this.state.errorMessage ? (
                                                <p className="c-auth-page__error-message">
                                                    {this.state.errorMessage}
                                                </p>
                                            ) : null}
                                            <div className="c-auth-page__auth-form--below mt-29 text-center">
                                                By signing up I agree to Aura’s
                                                <Popup
                                                    className="c-help-popup c-popup-wrapper c-help-popup-terms"
                                                    modal
                                                    lockScroll
                                                    onOpen={
                                                        this.handlePopupOpen
                                                    }
                                                    onClose={
                                                        this.handlePopupClose
                                                    }
                                                    trigger={
                                                        <span className="cursor-pointer font-normal link-underline o-d-inline-block">
                                                            Terms of Use
                                                        </span>
                                                    }
                                                >
                                                    {(close) => (
                                                        <>
                                                            <div className="c-popup">
                                                                <div className="c-popup__header text-center">
                                                                    <span className="c-popup__header--subtitle mb-30 o-d-block font-20 font-orange font-bold">
                                                                        {
                                                                            this
                                                                                .state
                                                                                .termsTitle
                                                                        }
                                                                    </span>
                                                                </div>

                                                                <div className="c-popup__body font-500 font-18 font-333 opacity-9">
                                                                    {ReactHtmlParser(
                                                                        this
                                                                            .state
                                                                            .terms
                                                                    )}
                                                                </div>

                                                                <button
                                                                    className="c-popup__close btn btn--full btn--smaller"
                                                                    onClick={
                                                                        close
                                                                    }
                                                                >
                                                                    Got it,
                                                                    close this
                                                                </button>
                                                            </div>
                                                            <button
                                                                onClick={close}
                                                                className="c-popup-wrapper-overlay__close btn-icon position-absolute"
                                                            >
                                                                <i className="icon-times font-35 cursor-pointer"></i>
                                                            </button>
                                                        </>
                                                    )}
                                                </Popup>
                                            </div>
                                        </Form>

                                        <h1 className="text-center width-full font-16 c-auth-page__auth-form--cta mt-10 mb-30 ">
                                            <span className="already-have-label">
                                                Already have an Aura Account?
                                            </span>{' '}
                                            <span>
                                                <Link
                                                    className="link-underline already-have-label"
                                                    to="/login"
                                                >
                                                    Sign in
                                                </Link>
                                            </span>
                                        </h1>
                                    </div>
                                    <SecurityFooter tablet={false} />
                                </>
                            );
                        }}
                    </Formik>
                    <SlickSlider />
                </div>
            );
        }

        return register;
    }
}

function Checkbox({ field, type }) {
    return (
        <div className="c-field-checkbox o-flex o-flex-middle position-relative">
            <input
                className="c-field-checkbox__input position-absolute z-index-1 position-alignment margin-reset"
                id="newsletter-checkbox"
                {...field}
                type={type}
            />
            <label
                htmlFor="newsletter-checkbox"
                className="c-field-checkbox__label position-relative"
            >
                Sign up for email updates, tips and expert advice
            </label>
        </div>
    );
}

export default Register;
